@if(breakpointService.isDesktop()) {
  <div class="occasion-genius">
    <div class="occasion-genius__header">
      <h3 class="occasion-genius__title">
        {{ 'OCCASION_GENIUS.MOST_POPULAR_EVENTS_IN' | translate: { date: searchInCityPeriod || '' } }}
      </h3>
    </div>

    <div class="occasion-genius__content">
      @if (!isFetching) {
        @if (occasionGeniusResponse.eventsSearchedAndSorted.length) {
          @for (event of visibleEvents; track event.uuid) {
            @if(getCardEvent(event); as cardEvents) {
              @if(cardEvents[0]) {
                <app-occasion-genius-card
                  [events]="cardEvents"
                  [isFetching]="isFetching"
                  [placeId]="cityId"
                  [cityName]="cityName"
                  [countryName]="countryName"
                ></app-occasion-genius-card>
              }
            }
          }
        } @else {
          <div class="occasion-genius__empty">
            {{ 'OCCASION_GENIUS.EVENT_NOT_FOUND' | translate }}
          </div>
        }
      } @else {
        @for (event of fetchingEvents; track $index) {
          <app-occasion-genius-card
            [events]="[null]"
            [isFetching]="true"
            [cityName]="cityName"
            [countryName]="countryName"
          ></app-occasion-genius-card>
        }
      }
    </div>

    @if (occasionGeniusResponse?.eventsSearchedAndSorted?.length) {
      @if (visibleEvents?.length < this.occasionGeniusResponse?.eventsSearchedAndSortedCloned?.length && visibleEvents?.length) {
        <div class="occasion-genius__footer">
          <button (click)="onShowMore()">
            Show more events
          </button>
        </div>
      }
    }
  </div>
} @else {
  <app-occasion-genius-list-mobile
    [title]="title"
    [isFetching]="isFetching"
    [countryName]="countryName"
    [cityName]="cityName"
    [cityId]="cityId"
    [occasionGeniusResponse]="occasionGeniusResponse"
    [groupEvents]="occasionGeniusResponse.eventsSearchedAndSortedCloned"
  ></app-occasion-genius-list-mobile>
}
